"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Header_1 = __importDefault(require("./Header"));
const Footer_1 = __importDefault(require("./Footer"));
function Layout(htmlContent, headerContent) {
    const layoutHTML = `
  <div class="w-full flex flex-col justify-center items-center mx-auto bg-black-400">
    ${(0, Header_1.default)()}
    <main class="w-full sm:w-5/6 md:w-medium mx-auto pb-16 min-h-screen">
      <div class="py-4 sm:py-8">
        ${headerContent ? `<div>${headerContent}</div>` : ``}
        ${htmlContent}
      </div>
    </main>
    ${(0, Footer_1.default)()}
  </div>
  `;
    const template = document.createElement("template");
    template.innerHTML = layoutHTML.trim();
    return template.content.firstChild;
}
exports.default = Layout;
